import { environment } from '@environments/environment';

export const GET_ALL_ACTIVE_STORES_QUERY = () => ({
  query: '_search',
  index: environment.integrations?.fournierWebservice?.index_store ?? '',
  body: {
    query: {
      bool: {
        filter: [
          {
            term: {
              search_api_datasource: 'entity:node',
            },
          },
          {
            exists: {
              field: 'uuid',
            },
          },
        ],
        must_not: [
          {
            geo_distance: {
              distance: '1m',
              latlon: {
                lat: 0.0,
                lon: 0.0,
              },
            },
          },
        ],
      },
    },
    from: 0,
    size: 10000,
  },
});
